import { BrokerageTrackingCredentialsPanel } from "../BrokerageTrackingCredentialsPanel";
import { MacropointTrackingVendorOptionsPanel } from "../MacropointTrackingVendorOptionsPanel";
import { MainBrokerageTrackingControlPanel } from "../MainBrokerageTrackingControlPanel";
import { DataSource, Layout, Panel, Switch } from "@mcleod/components";

export abstract class AutogenLayoutBrokerageTrackingControlPanel extends Layout {
    layoutBrokerageTrackingCredentialsPanel: BrokerageTrackingCredentialsPanel;
    layoutMainBrokerageTrackingControlPanel: MainBrokerageTrackingControlPanel;
    layoutVendorPanel: MacropointTrackingVendorOptionsPanel;
    mainContainerPanel: Panel;
    panel1: Panel;
    sourceBrTrackingCtrl: DataSource;
    sourceBrTrackingDocTypeMap: DataSource;
    switchIsActive: Switch;
}
